export const IMAGE_BASE_URL = process.env.IMAGE_RESIZER_PROXY_URI + '/assets/';
export const MAX_OFFER_IMAGES_COUNT = 5;
export const PAGE_SIZE = 12;
export const MAX_FILE_SIZE_IN_BYTES = 25 * 1000 * 1000;

export const BROWSE_IMAGES_PATHNAME = 'browse-images';
export const EDIT_IMAGES_PATHNAME = 'edit-images';
export const ADD_TO_OFFERS_PATHNAME = 'add-to-offers';
